export default __webpack_public_path__ + "static/ITCAvantGardeStd-Bk-ae29d873e438d4a0eb797c165a942ee0.woff";